import {Dispatch, ReactElement, SetStateAction} from "react";
import {useTranslation} from "react-i18next";
import {SavedCartModal} from "../../SavedCarts/TransferSavedCartToCart";
import {WZDownloadFormat} from "../types";

type DocumentActionsProps = {
    id: number;
    setCartThrobber: Dispatch<SetStateAction<boolean>>;
    downloading: WZDownloadFormat | null;
    downloadError: boolean;
    download: (format: WZDownloadFormat) => Promise<void>;
};

export function DocumentActions({
    id,
    setCartThrobber,
    downloading,
    downloadError,
    download,
}: DocumentActionsProps): ReactElement {
    const {t} = useTranslation();

    return (
        <div className="wz-actions">
            <h2>{t('user-page.wz.actions')}</h2>
            <div className="buttons">
                <SavedCartModal
                    setThrobber={setCartThrobber}
                    endpoint="/user/wz/transform-to-cart"
                    idItem={id}
                />
                <button type="button" className="btn teal" disabled={downloading !== null} onClick={() => void download('xls')}>
                    <i className="fas fa-file-excel" /> XLS
                </button>
                <button type="button" className="btn teal" disabled={downloading !== null} onClick={() => void download('pdf')}>
                    <i className="fas fa-file-pdf" /> PDF
                </button>
            </div>
            {downloadError && (
                <div className="form-error">
                    <i className="fas fa-times-circle" />
                    <span>{t('user-page.wzs.download-error')}</span>
                </div>
            )}
        </div>
    );
}
